import { render, staticRenderFns } from "./deleteContractTypeSpec.vue?vue&type=template&id=fd77f964&scoped=true"
import script from "./deleteContractTypeSpec.vue?vue&type=script&lang=js"
export * from "./deleteContractTypeSpec.vue?vue&type=script&lang=js"
import style0 from "./deleteContractTypeSpec.vue?vue&type=style&index=0&id=fd77f964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd77f964",
  null
  
)

export default component.exports